<div class="update-status-container">
  <div fxLayout="row" fxLayoutAlign="space-between center">
    <div class="title fc_DEDEDE">Status change</div>
    <mat-icon fontSet="material-icons-round" (click)="cancel()" style="color: #dedede;">close</mat-icon>
  </div>

  <div class="description fc_DEDEDE">You are changing the status of property</div>
  <div fxLayout="row wrap" fxLayoutGap="8px">
    <div class="property-name" *ngFor="let property of properties">{{property.unitNum}}</div>
  </div>
  <div class="description fc_DEDEDE">to status</div>
  <div style="color: rgba(222, 222, 222, 0.4);">
    <ng-container *ngIf="targetStatus === 0">
      <span class="status-point" style="background: #B0DDCD"></span>Unavailable
    </ng-container>
    <ng-container *ngIf="targetStatus === 1">
      <span class="status-point" style="background: #03BC79"></span>Available
    </ng-container>
    <ng-container *ngIf="targetStatus === 2 || targetStatus === 3">
      <span class="status-point" style="background: #FFC01D"></span>Reserved
    </ng-container>
    <ng-container *ngIf="targetStatus === 4 || targetStatus === 5">
      <span class="status-point" style="background: #2589FE"></span>Processing
    </ng-container>
    <ng-container *ngIf="targetStatus === 6">
      <span class="status-point" style="background: #B0B0B0"></span>Sold
    </ng-container>
  </div>
  <div fxLayout="row" fxLayoutAlign="end">
    <button mat-flat-button class="cancel-button" (click)="cancel()">Back</button>
    <button mat-flat-button class="confirm-button" (click)="confirm()">Update</button>
  </div>
</div>